import { TabFields } from '@cmhc-schl/hearth-ui';
import { UnderwritingApprovedLenderName } from 'Feature/V2/HbtMasterPool/components/HbtMasterPoolLoansInventoryTable/types';

interface StatusHistoryDetail {
  originalAccountStatusTypeCode?: string;
  recordCreatedTimestamp?: string;
  recordCreatedUserID?: string;
}
interface RemarksDetail {
  remarkId?: number;
  remarkText?: string;
  recordUpdatedTimestamp?: string;
  recordCreatedTimestamp?: string;
  recordCreatedUserID?: string;
  firstName?: string;
  lastName?: string;
}

export interface LoanInventoryTableFields {
  id: string;
  portfolioId: string;
  portfolioEpipProcessingStatus: string;
  cmhcAccountNumber: number;
  lenderReferenceNumber: string;
  loanStatus: string;
  propertyAddress: string;
  underwritingApprovedLenderCode: string;
  underwritingApprovedLenderName: UnderwritingApprovedLenderName;
  loanPremiumRate: number;
  errorMessageInfo?: string;
  lowRatioCmhcAccountNumber: string;
  lowRatioAccountNumber: string;
  insuredApprovedLenderCode: string;
  approvedLender?: approvedLender;
  reducedDatasetIndicator: boolean;
  remarks: RemarksDetail[];
  latestRemark?: RemarkDetail;
  statusHistory?: StatusHistoryDetail[];
  loanSequenceNumber?: number;
}
export interface RemarkDetail {
  remarkId: number;
  rationaleEnglish: string;
  rationaleFrench: string;
  remarkText?: string;
  recordTimestamp: string;
  userID: string;
  firstName: string;
  lastName: string;
}

export type approvedLender = {
  englishName: string;
  frenchName: string;
};

export type DataColumnType = {
  name: string;
  displayName: string;
  t: Function;
};

export type TabType = {
  label: { value: string };
  content: React.ReactNode;
  id: string;
};

export type HbtPortfolioLoansInventoryProps = {
  isCancellation: boolean;
  applicationID: string;
  portfolioIds: number[];
  handleViewLoanDetailsActionRowClick: (tabList: TabFields) => void;
  handleMutipleLoanDetailsActionClick: (tabList: TabFields[]) => void;
  openFlyout: boolean;
  setOpenFlyout: React.Dispatch<React.SetStateAction<boolean>>;
  openModifyRemarkFlyout: boolean;
  setModifyRemarkFlyout: React.Dispatch<React.SetStateAction<boolean>>;
};

export interface FilterOption {
  label: string;
  subLabel?: string;
  value: string;
  count?: number;
  severity?: string;
  chipLabel?: string;
}

export interface PortfolioCardProps {
  portfolioIds: number[];
}

export enum FlyoutType {
  modify = 'modify',
  update = 'update'
}

export enum ValidationReviewLoanStatus {
  FAILED = '03',
  PASS = '02',
  REVIEW_REQUIRED = '04'
}
